import React, { useEffect } from 'react';
import styled from 'styled-components';
import GlobalStyles from './styles/GlobalStyles';
import Home from './components/Home';

const App: React.FC = () => {
  // Add background image
  useEffect(() => {
    document.body.style.backgroundImage = 'url(/images/WheelBG.jpeg)';
    document.body.style.backgroundSize = 'cover';
    document.body.style.backgroundAttachment = 'fixed';
    document.body.style.backgroundPosition = 'center center';
    document.body.style.margin = '0';
    document.body.style.padding = '0';
    document.body.style.border = 'none';
    
    return () => {
      document.body.style.backgroundImage = '';
      document.body.style.backgroundSize = '';
      document.body.style.backgroundAttachment = '';
      document.body.style.backgroundPosition = '';
      document.body.style.margin = '';
      document.body.style.padding = '';
      document.body.style.border = '';
    };
  }, []);

  return (
    <AppContainer>
      <GlobalStyles />
      <Home />
    </AppContainer>
  );
};

const AppContainer = styled.div`
  flex: 1;
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export default App;